export const RAG_COLORS = {
    0   : '#FF493D',
    1   : '#F5B800',
    2   : '#43C464',
    none: '#787B80'

}